import { BookOpen } from 'lucide-react';
import { Link } from 'react-router-dom';

import { WorkedExamples } from '../components/annotation/WorkedExamples.jsx';

/**
 * Worked examples on their own page.
 *
 * They also appear under the guidelines, but that page is long and they sit at the
 * bottom of it - which is no good for something meant to be consulted while deciding how
 * to tag something.
 */
export function ExamplesPage() {
  return (
    <div className="page wide">
      <div className="page-head">
        <h1>Examples</h1>
        <p>
          Finished annotations to refer to before and while you annotate. Read-only —
          nothing here changes anyone&rsquo;s work.
        </p>
      </div>

      <WorkedExamples standalone />

      <p className="tiny muted" style={{ marginTop: 'var(--space-5)' }}>
        <Link to="/guidelines">
          <BookOpen size={12} /> Back to the full guidelines
        </Link>
      </p>
    </div>
  );
}
